@let exchangeRate = exRateService.exRate$ | async;
@let currencyCode = showCurrency ? (exchangeRate?.SYMBOL ?? "") : "";
<div class="balance-display">
  <mat-icon (click)="balanceService.refreshExposure()" class="refresh-icon header-text" [ngClass]="{ 'refresh-spin': $loading | async }">refresh</mat-icon>
  <!--  @if (isDev) {-->
  <!--    <select class="wallet-select">-->
  <!--      <option>Main Wallet</option>-->
  <!--      <option>Casino Wallet</option>-->
  <!--    </select>-->
  <!--  }-->
  <div class="value-pair">
    <span class="balance-label header-text">{{ "Balance" | translate }}:&nbsp;</span>
    <span class="balance-value header-text balance-val">{{ currencyCode }}&nbsp;{{ balance | number: "1.2-2" }}</span>
  </div>
  <div class="divider"></div>
  <div class="value-pair">
    <span class="balance-label header-text">{{ "Exposure" | translate }}:&nbsp;</span>
    <span class="balance-value header-text exposure-val">{{ currencyCode }}&nbsp;{{ totalExposure | number: "1.2-2" }}</span>
  </div>
  <div class="divider"></div>
  <div class="value-pair">
    <span class="balance-label header-text">{{ "Avl. to bet" | translate }}:&nbsp;</span>
    <span class="balance-value header-text exposure-val">{{ currencyCode }}&nbsp;{{ availableToBet | truncateNumber }}</span>
  </div>
  <div class="divider"></div>
  <app-user-button />
</div>
